import { GoalsTrackingViewDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum GoalsTrackingWSEvents {
  GOALS_UPDATED = '[Goals Tracking]  Goals Updated',
}

/**
 * Payloads
 */
export interface GoalsUpdatedWSPayload {
  goalsTrackingView: GoalsTrackingViewDto;
}

/**
 * Events
 */
export class GoalsUpdatedWSMessage {
  type: string;
  constructor(public payload: GoalsUpdatedWSPayload) {
    this.type = GoalsTrackingWSEvents.GOALS_UPDATED;
  }
}
